<!-- 策略热门股 -->
<template>
  <div class="clrmgMore" :class="$route.query.themeStyleVs === 2 ? 'black_theme' : 'white_theme'">
    <div class="clrmgMore-nav">
      <van-nav-bar title="策略热门股" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="content">
      <p class="hint">今日入选策略数量Top9的股票</p>

      <ul class="lzg_list">
        <li v-for="(item, index) in lzgList" :key="item.stock" class="lzg_list_li">
          <template v-if="index < 9">
            <div class="top">
              <div class="left" @click="gotoDetail(item.stock)">
                <span
                  class="index"
                  :style="
                    index === 0
                      ? { 'background-image': `url(${require(`@/assets/image/phb1_2x.png`)}` }
                      : index === 1
                      ? { 'background-image': `url(${require(`@/assets/image/phb2_2x.png`)}` }
                      : index === 2
                      ? { 'background-image': `url(${require(`@/assets/image/phb3_2x.png`)}` }
                      : index > 2
                      ? { 'background-image': `url(${require(`@/assets/image/phb4_2x.png`)}` }
                      : ''
                  "
                >
                  {{ index + 1 }}
                </span>

                <div class="l_r">
                  <p class="name">{{ item.ZhongWenJianCheng }}</p>
                  <p class="code">{{ item.stock.slice(2, 9) }}</p>
                </div>
              </div>

              <div class="right">
                <span class="involvedCount">入选{{ item.number }}个</span>
                <span class="rate" :class="[judgeBgColor(item.ZhangFu)]">
                  {{ toFixedNum(item.ZhangFu, 2, '%') }}
                </span>

                <p class="operate" v-if="clickIndex !== index" @click="handleClickCard(index)">
                  展开
                </p>
                <p class="operate" v-else @click="handleClickCard(index)">收起</p>
              </div>
            </div>

            <ul class="bottom_ul" v-if="clickIndex === index">
              <li v-for="(item2, index2) in item.clList" :key="index2" @click="goclDetail(item2)">
                <p class="t_name">
                  <span>{{ item2.s_name }}</span>
                  <span class="zf" :class="[judgeColor(item2.RiZhangFu)]">
                    {{ toFixedNum(item2.RiZhangFu * 100, 2, '%') }}
                  </span>
                </p>
                <p class="desc van-ellipsis">{{ item2.s_desc }}</p>
                <van-row gutter="4">
                  <van-col span="8">
                    <div class="block">
                      <p class="zf" :class="[judgeColor(item2.BestAvgRate)]">
                        {{ toFixedNum(item2.BestAvgRate * 100, 2, '%') }}
                      </p>
                      <p class="name">最优涨幅·{{ item2.BestAvgCycle }}天</p>
                    </div>
                  </van-col>
                  <van-col span="8">
                    <div class="block">
                      <p class="zf" :class="[judgeColor(item2.MaxRiseRate)]">
                        {{ toFixedNum(item2.MaxRiseRate * 100, 2, '%') }}
                      </p>
                      <p class="name">最大概率·{{ item2.MaxRiseCycle }}天</p>
                    </div>
                  </van-col>
                  <van-col span="8">
                    <div class="block">
                      <p class="zf zf_black">{{ item2.XinHaoShuLiang }}</p>
                      <p class="name">今日信号</p>
                    </div>
                  </van-col>
                </van-row>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getClHotStock, getFactorHq } from '@/api/index.js';
import { judgeBgColor, judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'ClrmgMore',
  mixins: [mixin],
  props: [],

  data() {
    return {
      lzgList: [],
      clickIndex: null,
      isVip: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getClHotStockFun();
  },
  methods: {
    judgeBgColor,
    judgeColor,
    toFixedNum,
    compareVersions,

    onClickLeft: function () {
      this.$router.go(-1);
    },

    handleClickCard(index) {
      if (this.clickIndex === index) {
        // 如果当前索引已经是展开状态，则隐藏
        this.clickIndex = null;
      } else {
        // 否则展开
        this.clickIndex = index;
        // 请求策略的今日信号跟涨幅
        this.getClHq(index);
      }
    },

    getClHotStockFun: function () {
      let params = {};
      return getClHotStock(params)
        .then((res) => {
          this.lzgList = res.data;
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    cancelBasis: function (e) {
      this.takeShow = e;
    },

    // 跳转策略详情
    goclDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92) ) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0703'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/clDetail?DZHSPECIAL=4325641&type=hot&s_id=' + item.s_id;
      }
    },
    //  批量获取策略的今日涨幅跟信号数
    getClHq: function (index) {
      //   获取当前策略的集合
      let listInfo = this.lzgList[index].clList;
      //   整理请求条件,把listInfo中的f_id_arr提取出来,用逗号隔开
      let f_id_arr = listInfo
        .map((item) => {
          return item.f_id_arr;
        })
        .join(',');
      // 整理条件
      let params = {
        groupID: f_id_arr,
        type: 'cl'
      };
      // 请求行情
      getFactorHq(params)
        .then((res) => {
          if (res.err === 200) {
            this.lzgList[index].clList.map((item1) => {
              const item2 = res.data.find((item) => item.ID == item1.f_id_arr);
              if (item2) {
                return {
                  ...item1,
                  RiZhangFu: item2.RiZhangFu,
                  ID: item2.ID,
                  XinHaoShuLiang: item2.XinHaoShuLiang
                };
              } else {
                return {
                  ...item1,
                  RiZhangFu: undefined,
                  ID: undefined,
                  XinHaoShuLiang: undefined
                };
              }
            });
          } else {
            this.lzgList[index].clList.forEach((item) => {
              item.RiZhangFu = undefined;
              item.ID = undefined;
              item.XinHaoShuLiang = undefined;
            });
          }
        })
        .catch((err) => {
          this.lzgList[index].clList.forEach((item) => {
            item.RiZhangFu = undefined;
            item.ID = undefined;
            item.XinHaoShuLiang = undefined;
          });
        });
    },
    gotoDetail: function (code) {
      this.gogufs(code);
    }
  }
};
</script>
<style lang="less" scoped>
.clrmgMore {
  .clrmgMore-nav {
    ::v-deep {
      .van-hairline--bottom::after {
        display: none;
      }

      .van-nav-bar {
        padding-top: 40px;
        background: none;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        padding: 0 16px;
      }

      .van-icon,
      .van-nav-bar__title {
        color: #333;
      }
    }
  }

  .content {
    .hint {
      border-radius: 4px;
      background: #f7f7fc;
      color: #999;
      font-size: 12px;
      padding: 6px 12px;
      margin: 4px 16px;
    }

    .lzg_list {
      padding: 6px 0;
      overflow-y: auto;
      height: calc(100vh - 123px);

      .lzg_list_li {
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 4px 16px;

          .left,
          .right {
            display: flex;
            align-items: center;
          }

          .left {
            .index {
              width: 16px;
              height: 16px;
              flex-shrink: 0;
              border-radius: 4px;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: #fff;
            }

            .l_r {
              margin-left: 12px;

              .name {
                color: #555;
                font-size: 16px;
                font-weight: 500;
              }

              .code {
                color: #999;
                font-size: 12px;
              }
            }
          }

          .right {
            font-size: 12px;

            .involvedCount {
              color: #999;
            }

            .rate {
              color: #fff;
              border-radius: 4px;
              width: 52px;
              height: 22px;
              line-height: 22px;
              text-align: center;
              margin: 0 8px;
            }

            .operate {
              color: #286df7;
            }
          }
        }

        .bottom_ul {
          background: #f7f8fa;
          padding: 8px;

          li {
            border-radius: 6px;
            background: #fff;
            padding: 8px 12px;
            margin-bottom: 8px;
            .t_name {
              color: #555;
              font-size: 16px;
              font-weight: 500;
              margin-bottom: 4px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }

            .desc {
              color: #999;
              font-size: 12px;
              margin-bottom: 8px;
            }

            .block {
              border-radius: 4px;
              background: #f7f8fa;
              text-align: center;
              padding: 8px 0;

              .zf {
                font-size: 14px;
                font-weight: 600;
                color: #555;
              }

              .name {
                margin-top: 2px;
                color: #999;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  background: #1a1c26;

  .clrmgMore-nav {
    ::v-deep {
      .van-icon,
      .van-nav-bar__title {
        color: #fff;
      }
    }
  }

  .content {
    .hint {
      background: #272935;
      color: #6b7687;
    }

    .lzg_list {
      .name {
        color: #aab9d1 !important;
      }

      .code {
        color: #6b7687 !important;
      }

      .involvedCount {
        color: #6b7687 !important;
      }

      .operate {
        color: #3b85fe !important;
      }

      .bottom_ul {
        background: #0c0f13 !important;

        li {
          background: #181a23 !important;

          .t_name,
          .desc {
            color: #aab9d1 !important;
          }

          .block {
            background: #1d202d !important;

            .zf_black {
              color: #aab9d1 !important;
            }

            .name {
              color: #6b7687;
            }
          }
        }
      }
    }
  }
}
</style>
